import ProductRange from "../components/ProductRange";
import ProductDetails from "../components/ProductDetails";
import RaneSection from "../components/RaneSection";
import FinalCTA from "../components/FinalCTA";

export default function RangePage() {
  return (
    <>
      <div className="pt-28 md:pt-32" />
      <ProductRange />
      <RaneSection variant="alt" />
      <ProductDetails />
      <FinalCTA />
    </>
  );
}
